import {FilePicker} from '@/components';

const RatesUploadForm = ({
  handleRatesUpload,
  handleTemplateDownload,
  dataCy,
}: {
  handleRatesUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleTemplateDownload: () => Promise<void>;
  /** Test hook prefix; the template link and the file picker namespace under it. */
  dataCy?: string;
}) => {
  return (
    <section className="rates-upload p-8 border-2 dark:border-dark-borderMid rounded-md mt-10 w-600">
      <aside className="rates-file-top dark:bg-dark-background dark:text-gray-200">
        File Upload
      </aside>
      <p
        data-cy={dataCy ? `${dataCy}-template` : undefined}
        className="download-rate-template justify-right"
        onClick={handleTemplateDownload}
      >
        **Download otc rate file template**
      </p>

      <FilePicker
        isLoading={false}
        label={
          <>
            OTC Rates file upload <span className="text-red-500">*</span>
          </>
        }
        name="otcRatesUpload"
        accept="text/csv"
        onChange={handleRatesUpload}
        className="mt-10"
        dataCy={dataCy ? `${dataCy}-file` : undefined}
      />

      <p className="my-12" />
    </section>
  );
};

export default RatesUploadForm;
